export default () => import(/* webpackChunkName: 'coffee/activities/membership/beans-detail' */ './BeansDetail');
